import ReactFastMarquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/config/site";
import { MapleMark } from "@/components/MapleMark";

export default function Marquee() {
  return (
    <section aria-hidden="true" className="noise-dark bg-brand-deep py-6">
      <ReactFastMarquee speed={40} gradient={false} pauseOnHover>
        {MARQUEE_WORDS.map((word) => (
          <span
            key={word}
            className="mx-9 flex items-center gap-9 font-cabinet text-lg font-bold tracking-tight text-white/50"
            data-testid="marquee-word"
          >
            {word}
            <MapleMark className="h-3.5 w-3.5 text-accent" />
          </span>
        ))}
      </ReactFastMarquee>
    </section>
  );
}
